declare namespace $ {

	type $mol_image__uri_bog_music_track_1 = $mol_type_enforce<
		ReturnType< $bog_music_track['cover'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__event_bog_music_track_2 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_music_track['on_play_click'] > ): ReturnType< $bog_music_track['on_play_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_track_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_track_4 = $mol_type_enforce<
		ReturnType< $bog_music_track['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_music_track_5 = $mol_type_enforce<
		ReturnType< $bog_music_track['artist'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__event_bog_music_track_6 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_music_track['on_play_click'] > ): ReturnType< $bog_music_track['on_play_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_track_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_music_track_8 = $mol_type_enforce<
		({ 
			'bog_music_track_share_button': boolean,
			'bog_music_track_share_selected': ReturnType< $bog_music_track['share_selected'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_music_track_9 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_track['share_pointer_down'] > ): ReturnType< $bog_music_track['share_pointer_down'] >,
			pointerup( next?: ReturnType< $bog_music_track['share_pointer_up'] > ): ReturnType< $bog_music_track['share_pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_track['share_pointer_cancel'] > ): ReturnType< $bog_music_track['share_pointer_cancel'] >,
			pointerleave( next?: ReturnType< $bog_music_track['share_pointer_leave'] > ): ReturnType< $bog_music_track['share_pointer_leave'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_track_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_music_track_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_track_12 = $mol_type_enforce<
		ReturnType< $bog_music_track['menu_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_15 = $mol_type_enforce<
		ReturnType< $bog_music_track['demote_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_18 = $mol_type_enforce<
		ReturnType< $bog_music_track['pull_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_21 = $mol_type_enforce<
		ReturnType< $bog_music_track['delete_cached'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_24 = $mol_type_enforce<
		ReturnType< $bog_music_track['archive_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_27 = $mol_type_enforce<
		ReturnType< $bog_music_track['move_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_28 = $mol_type_enforce<
		ReturnType< $bog_music_track['move_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_30 = $mol_type_enforce<
		ReturnType< $bog_music_track['restore_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_track_33 = $mol_type_enforce<
		ReturnType< $bog_music_track['delete_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_track_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_track_35 = $mol_type_enforce<
		ReturnType< $bog_music_track['menu_items'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop__Anchor_bog_music_track_36 = $mol_type_enforce<
		ReturnType< $bog_music_track['Menu_anchor'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_music_track_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_paragraph__title_bog_music_track_38 = $mol_type_enforce<
		ReturnType< $bog_music_track['confirm_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_minor__title_bog_music_track_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_track_40 = $mol_type_enforce<
		ReturnType< $bog_music_track['delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_bog_music_track_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_music_track_42 = $mol_type_enforce<
		ReturnType< $bog_music_track['delete_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_bog_music_track_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_track_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_track extends $mol_view {
		blob_pending( ): boolean
		event_drag_start( next?: any ): any
		event_drag_over( next?: any ): any
		event_drop( next?: any ): any
		on_play_click( next?: any ): any
		Cover( ): $mol_image
		Cover_placeholder( ): $mol_icon_music
		Cover_box( ): $mol_view
		title( ): string
		Title( ): $mol_paragraph
		artist( ): string
		Artist( ): $mol_paragraph
		Info( ): $mol_view
		share_pointer_down( next?: any ): any
		share_pointer_up( next?: any ): any
		share_pointer_cancel( next?: any ): any
		share_pointer_leave( next?: any ): any
		Share_icon( ): $mol_icon_share
		Share( ): $mol_view
		menu_toggle( next?: any ): any
		Menu_icon( ): $mol_icon_dots_vertical
		Menu_anchor( ): $mol_button_minor
		demote_click( next?: any ): any
		Demote_icon( ): $mol_icon_format_vertical_align_bottom
		Demote_label( ): $mol_view
		Demote( ): $mol_button_minor
		pull_click( next?: any ): any
		Pull_icon( ): $mol_icon_download
		pull_label( ): string
		Pull_label( ): $mol_view
		Pull( ): $mol_button_minor
		delete_cached( next?: any ): any
		Delete_icon( ): $mol_icon_delete
		Delete_label( ): $mol_view
		Delete( ): $mol_button_minor
		archive_click( next?: any ): any
		Archive_icon( ): $mol_icon_archive
		Archive_label( ): $mol_view
		Archive( ): $mol_button_minor
		move_click( id: any, next?: any ): any
		Move_add_icon( id: any): $mol_icon_playlist_plus
		Move_cut_icon( id: any): $mol_icon_playlist_remove
		move_label( id: any): string
		Move_label( id: any): $mol_view
		move_content( id: any): readonly(any)[]
		Move( id: any): $mol_button_minor
		restore_click( next?: any ): any
		Restore_icon( ): $mol_icon_restore
		Restore_label( ): $mol_view
		Restore( ): $mol_button_minor
		delete_ask( next?: any ): any
		Delete_forever_icon( ): $mol_icon_delete_forever
		Delete_forever_label( ): $mol_view
		Delete_forever( ): $mol_button_minor
		menu_items( ): readonly(any)[]
		Menu_panel( ): $mol_view
		Menu( ): $mol_pop
		content( ): readonly(any)[]
		confirm_text( ): string
		Confirm_text( ): $mol_paragraph
		delete_cancel( next?: any ): any
		Confirm_no( ): $mol_button_minor
		delete_confirm( next?: any ): any
		Confirm_yes( ): $mol_button_major
		Confirm_actions( ): $mol_view
		key( ): string
		current( ): boolean
		play( next?: any ): any
		archive_mode( ): boolean
		can_drag( ): boolean
		drag_start( next?: any ): any
		drop_here( next?: any ): any
		archive( next?: any ): any
		restore( next?: any ): any
		delete_forever( next?: any ): any
		demote( next?: any ): any
		share_selected( ): boolean
		cover( ): string
		attr( ): ({ 
			'bog_music_track_current': ReturnType< $bog_music_track['current'] >,
			'bog_music_track_share_selected': ReturnType< $bog_music_track['share_selected'] >,
			'bog_music_track_pending': ReturnType< $bog_music_track['blob_pending'] >,
			'draggable': ReturnType< $bog_music_track['can_drag'] >,
		}) 
		event( ): ({ 
			dragstart( next?: ReturnType< $bog_music_track['event_drag_start'] > ): ReturnType< $bog_music_track['event_drag_start'] >,
			dragover( next?: ReturnType< $bog_music_track['event_drag_over'] > ): ReturnType< $bog_music_track['event_drag_over'] >,
			drop( next?: ReturnType< $bog_music_track['event_drop'] > ): ReturnType< $bog_music_track['event_drop'] >,
		}) 
		sub( ): ReturnType< $bog_music_track['content'] >
		Confirm( ): $mol_view
	}
	
}

//# sourceMappingURL=track.view.tree.d.ts.map